import { Checkbox, Stack, Typography } from '@mui/material';
import Konva from 'konva';
import { useTranslation } from 'react-i18next';
import { IProduct } from '../../shared/iProject';
import { EFontWeight } from '../../shared/style/enum';
import variable from '../../shared/style/variable';
import ProductMaccaferriPattern from './image/product_macca_pattern.svg';

const changeTextureColor = (texture: string, color: string): string => {
    let decodedImage = atob(texture.substring(26));
    decodedImage = decodedImage.replaceAll('currentColor', color);
    return 'data:image/svg+xml;base64,' + btoa(decodedImage);
};

export const getTextureByProduct = (product: IProduct): string => {
    if (product.isMaccaferriManufacturer) {
        return changeTextureColor(ProductMaccaferriPattern, product.color!);
    } else {
        return '';
    }
};

export const getImageSourceBase64 = (svgElement: any) => {
    const svgData = new XMLSerializer().serializeToString(svgElement);
    var decoded = unescape(encodeURIComponent(svgData));
    var base64 = btoa(decoded);
    return `data:image/svg+xml;base64,${base64}`;
};

export const loadImages = (sources: any, callback: (images: any) => void) => {
    var images = {};
    var loadedImages = 0;
    var numImages = 0;
    for (var src in sources) {
        numImages++;
    }
    for (var src in sources) {
        (images as any)[src] = new Image();
        (images as any)[src].onload = function () {
            if (++loadedImages >= numImages) {
                callback(images);
            }
        };
        (images as any)[src].src = (sources as any)[src];
    }
};

interface ILegendProps {
    data?: (ILegend | undefined)[];
}

export interface ILegend {
    name: string;
    logo: string;
    value?: number | string;
    width?: number;
    height?: number;
    onChange?: (e: React.ChangeEvent<any>) => void;
}

export const Legend = (props: ILegendProps) => {
    const { t } = useTranslation();
    return (
        <Stack direction={'column'} style={{ backgroundColor: variable.grey_100 }} padding={1}>
            {props.data?.map(
                x =>
                    x !== undefined && (
                        <Stack key={x.name} direction={'row'} gap={0.5} alignItems={'center'}>
                            {x.onChange !== undefined && <Checkbox style={{ padding: 0 }} size='small' defaultChecked onChange={(e: any) => x.onChange!(e)} name={x.name} />}
                            <Stack width={30} alignItems={'center'}>
                                <img src={x.logo} width={x.width ? x.width : 30} alt={x.name} />
                            </Stack>
                            <Typography fontSize={'0.6rem'} fontWeight={EFontWeight.SemiBold}>
                                {t(x.name, { value: x.value })}
                            </Typography>
                        </Stack>
                    ),
            )}
        </Stack>
    );
};

export const setAngleIndicator = (x: number, y: number, angle: number) => [
    new Konva.Text({
        x: x + 32,
        y: y - 6,
        text: `${angle}°`,
        fontSize: 4,
        fontFamily: 'Calibri',
        fill: 'black',
    }),
    new Konva.Wedge({
        x: x + 1,
        y,
        radius: 30,
        angle,
        rotation: -angle,
        stroke: 'black',
        strokeWidth: 0.3,
    }),
];


export const setIndicatorX = (x: number, y: number, value: number) => [
    new Konva.Line({
        points: [x, y - 2, x, y + 2],
        stroke: 'black',
        strokeWidth: 0.5,
    }),
    new Konva.Line({
        points: [x + value, y - 2, x + value, y + 2],
        stroke: 'black',
        strokeWidth: 0.5,
    }),
    new Konva.Line({
        points: [x, y, x + value, y],
        stroke: 'black',
        strokeWidth: 0.5,
    }),
];

export const setIndicatorY = (x: number, y: number, value: number) => [
    new Konva.Line({
        points: [x - 2, y, x + 2, y],
        stroke: 'black',
        strokeWidth: 0.5,
    }),
    new Konva.Line({
        points: [x - 2, y + value, x + 2, y + value],
        stroke: 'black',
        strokeWidth: 0.5,
    }),
    new Konva.Line({
        points: [x, y, x, y + value],
        stroke: 'black',
        strokeWidth: 0.5,
    }),
];
